import jwtHelper from '../jwt/jwtHelper';

class Security {
    configure(store, types) {
        if (store) {
            this.store = store;
        }
    }

    isAuthorized() {
        const token = jwtHelper.getToken();
        return token && !jwtHelper.isTokenExpired(token);
    }

    login(token, payload, ACTION_TYPE) {
        jwtHelper.setToken(token);
        if (payload && payload.refreshToken) {
            jwtHelper.setRefreshToken(payload.refreshToken);
        }
    }

    logout(ACTION_TYPE) {
        jwtHelper.deleteToken();
        jwtHelper.deleteRefreshToken();

        if (this.store && ACTION_TYPE) {
            this.store.dispatch({
                type: ACTION_TYPE
            });
        }
    }

    getToken() {
        return jwtHelper.getToken();
    }

    getUser() {
        const token = jwtHelper.getToken();
        try {
            if (token && this.isAuthorized()) {
                return jwtHelper.decodeToken(token);
            }
        } catch (e) {
            // ignore decode errors and treat as unauthenticated
        }
        return {};
    }
}

const security = new Security();

export default security;
